// searchHighlight.ts — 검색어 매칭 부분을 <mark> 태그로 래핑하는 유틸리티.
// React 렌더용 ReactNode 배열 반환.
// match.in_name=true 이면 이름에 하이라이트, in_payload=true 이면 별도 표시.

/**
 * 원문 텍스트에서 query 매칭 부분을 배열로 분리한다.
 * 반환: [{text, highlight}] 배열 — highlight=true이면 <mark> 래핑 대상.
 */
export interface TextSegment {
  text: string;
  highlight: boolean;
}

/**
 * 원문 텍스트에서 검색어(대소문자 무시)가 매칭된 부분을 세그먼트로 분리한다.
 * @param text 원문 텍스트
 * @param query 검색어 (빈 문자열이면 전체를 비하이라이트로 반환)
 */
export function highlightSegments(text: string, query: string): TextSegment[] {
  if (!query.trim()) {
    return [{ text, highlight: false }];
  }

  const lower = text.toLowerCase();
  const lowerQuery = query.toLowerCase().trim();
  const segments: TextSegment[] = [];
  let pos = 0;

  while (pos < text.length) {
    const idx = lower.indexOf(lowerQuery, pos);
    if (idx === -1) {
      // 남은 텍스트는 비하이라이트
      segments.push({ text: text.slice(pos), highlight: false });
      break;
    }
    // 매칭 전 구간
    if (idx > pos) {
      segments.push({ text: text.slice(pos, idx), highlight: false });
    }
    // 매칭 구간
    segments.push({ text: text.slice(idx, idx + lowerQuery.length), highlight: true });
    pos = idx + lowerQuery.length;
  }

  return segments;
}

/**
 * 텍스트에 검색어 매칭이 있는지 확인한다 (대소문자 무시).
 */
export function hasMatch(text: string, query: string): boolean {
  if (!query.trim()) return false;
  return text.toLowerCase().includes(query.toLowerCase().trim());
}
